import { lazy } from 'react';
// project import
import Loadable from 'components/Loadable';
// import { RequireAuthorizedAccess } from "routes/guards/RequireAuthorizedAccess";
// import Permissions from "const/Permissions";
// ==============================|| ROUTES ITEMS - DASHBOARD ||============================== //

// render - shelling
const ShellingDefault = Loadable(
    lazy(() => import('pages/nostradamus/shelling/ShellingPage')),
);
const shelling = {
    path: '/shelling',
    element: (
        // <RequireAuthorizedAccess permissions={Permissions.DashboardSection.Dashboard}>
        <ShellingDefault />
        // </RequireAuthorizedAccess>
    ),
};

export default shelling;
